import { IssueStatus } from './issue-status';

export class IssueStatusGroup {
  code: string;
  label: string;
  description: string;
  issueStatuses: IssueStatus[];
  binaryStatusLabel: string;
  binaryStatusCode: string;
  isOpen: boolean;
  isClosed: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.code = payload.code;
      this.label = payload.label;
      this.description = payload.description;
      this.issueStatuses = payload.issueStatuses
        ? payload.issueStatuses.map((status: any) => new IssueStatus(status))
        : [];
      this.binaryStatusLabel = payload.binaryStatusLabel;
      this.binaryStatusCode = payload.binaryStatusCode;
      this.isOpen = payload.isOpen;
      this.isClosed = payload.isClosed;
    }
  }

  static createIssueStatusGroups(result: Array<any>): IssueStatusGroup[] {
    const issueStatusGroups = new Array<IssueStatusGroup>();
    if (result) {
      result.map((issueStatusGroup) => {
        issueStatusGroups.push(new IssueStatusGroup(issueStatusGroup));
      });
    }
    return issueStatusGroups;
  }
}
